import soilDataConfigApi from '@/api/config/soilDataConfigApi'
import { queryKeys } from '@/constant/common'
import { UpdateSoil } from '@/types/soil'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function update(payload: UpdateSoil): Promise<void> {
  await soilDataConfigApi.update(payload)
}

function useUpdateSoil() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: UpdateSoil) => update(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.soil])
      toast.success(t('updateSoilSuccessfully'))
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(
        error?.message ||
          t('UpdateSoilError'),
      )
    },
  })
}

export default useUpdateSoil
